import React, { Fragment } from "react";
import ClickCard from "./ClickCard";
import CardDeck from "react-bootstrap/CardDeck";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";

const ClickList = ({ clicks, linkMerchants, customerMerchants }) => {
  const [customerMerchant, setCustomerMerchant] = React.useState(false);
  const [linkMerchant, setLinkMerchant] = React.useState(false);
  const createOptions = () =>
    customerMerchants.map((data) => (
      <option key={data[0]} value={data[0]}>
        {data[1]}
      </option>
    ));
  const createOptions2 = () =>
    linkMerchants.map((data) => (
      <option key={data[0]} value={data[0]}>
        {data[1]}
      </option>
    ));
  const handleInputChange = React.useCallback((event) => {
    const target = event.target;
    const value = target.value === "All merchants" ? false : target.value;
    const name = target.name;

    setCustomerMerchant(value);
  }, []);
  const handleInputChange2 = React.useCallback((event) => {
    const target = event.target;
    const value = target.value === "All links" ? false : target.value;
    const name = target.name;

    setLinkMerchant(value);
  }, []);
  const filteredClicks =
    customerMerchant || linkMerchant
      ? clicks.filter(
          (click) =>
            click.customer_merchant_id == customerMerchant ||
            click.link_merchant_id == linkMerchant
        )
      : clicks;
  return (
    <Fragment>
      <Form className="d-inline-flex m-15 ">
        <Form.Row>
          <Form.Group as={Col} controlId="formCustomerMerchants">
            <Form.Label>
              <h4 className="mb-10 ">{"Customer Merchants"}</h4>
            </Form.Label>
            <Form.Control
              name="customerMerchant"
              onChange={handleInputChange}
              value={customerMerchant}
              as="select"
            >
              <option>All merchants</option>
              {createOptions()}
            </Form.Control>
          </Form.Group>
          <Form.Group as={Col} controlId="formLinkMerchants">
            <Form.Label>
              <h4 className="mb-10 ">{"Clicked Links"}</h4>
            </Form.Label>
            <Form.Control
              name="linkMerchant"
              onChange={handleInputChange2}
              value={linkMerchant}
              as="select"
            >
              <option>All links</option>
              {createOptions2()}
            </Form.Control>
          </Form.Group>
        </Form.Row>
      </Form>
      <h2>Selected Clicks - {filteredClicks.length} clicks </h2>
      <CardDeck style={{ flex: "none" }}>
        {filteredClicks.map((click, i) => {
          return (
            <ClickCard
              key={filteredClicks[i].id}
              customer_name={filteredClicks[i].customer}
              customer_id={filteredClicks[i].customer_id}
              customer_merchant_id={filteredClicks[i].customer_merchant_id}
              merchant={filteredClicks[i].merchant}
              date={filteredClicks[i].created_at}
              link={filteredClicks[i].link}
              link_merchant_id={filteredClicks[i].link_merchant_id}
            />
          );
        })}
      </CardDeck>
    </Fragment>
  );
};

export default ClickList;
